import TerminalAPI from '@/features/api/terminal/terminal'
import { PrintJobType } from '@/features/print/constants'
import { PrintEntry, Printer } from '@/features/print/types'
import { printData } from '@/features/print/utils/printData'

type Failure = {
    printer: Printer
    error: unknown
}

type PrintResult = {
    successes: Printer[]
    failures: Failure[]
}

const fetchPrinterCommand = (entry: PrintEntry, charsPerLine: number): Promise<string> => {
    switch (entry.printType) {
        case PrintJobType.KitchenBon:
            return TerminalAPI.printKitchenBon(entry.orderUuid, charsPerLine, false)
        case PrintJobType.DeliveryTicket:
            return TerminalAPI.printDeliveryTicket(entry.orderUuid, charsPerLine, false)
        case PrintJobType.Receipt:
            return TerminalAPI.printReceipt(entry.orderUuid, charsPerLine, false, entry.receiptType)
        case PrintJobType.OpenTabSubmissionBon:
            return TerminalAPI.printOpenTabSubmissionBon(entry.submissionUuid, charsPerLine, false)
        case PrintJobType.ShiftCloseout:
            return TerminalAPI.printShiftCloseout(entry.shiftCloseoutUuid, charsPerLine, false)
        default:
            throw new Error('Unsupported print type for printing.')
    }
}

export const printToPrinters = async (
    entry: PrintEntry,
    eligiblePrinters: Printer[]
): Promise<PrintResult> => {
    const results = await Promise.allSettled(
        eligiblePrinters.map(async (printer) => {
            const base64String = await fetchPrinterCommand(entry, printer.charsPerLine)

            await printData(base64String, printer.connectionOptions)
        })
    )

    const successes: Printer[] = []
    const failures: Failure[] = []

    results.forEach((result, index) => {
        const printer = eligiblePrinters[index]

        if (result.status === 'fulfilled') {
            successes.push(printer)
            return
        }

        failures.push({ printer, error: result.reason })
    })

    return { successes, failures }
}
